var APP_INTERFACE_CACHE_TAGS = {
  INIT_APP: 'InitApp',
  UPDATE_APP_EVENTS: 'UpdateAppEvents',
  GET_FACEBOOK_APP_ID: 'GetFacebookAppId'
};
APP_INTERFACE_CACHE_TAGS.updateAppEventsTagsArray = Object.values(APP_INTERFACE_CACHE_TAGS);
export { APP_INTERFACE_CACHE_TAGS };